import { render, staticRenderFns } from "./DependenciesList.vue?vue&type=template&id=044c8ba2"
import script from "./DependenciesList.vue?vue&type=script&lang=js"
export * from "./DependenciesList.vue?vue&type=script&lang=js"
import style0 from "./DependenciesList.vue?vue&type=style&index=0&id=044c8ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports